import { Set }           from 'immutable';
import {
  call,
  put,
  takeEvery
}                        from 'redux-saga/effects';
import { METHOD_GET }    from '../../actions/utils/apiResources/apiResourceActions.const';
import {
  buildMethodsByActionGroup,
  isApiRequestAction,
  parseApiAction
}                        from '../../actions/utils/apiResources/buildSyncActions';
import UserFriendlyError from '../../errors/UserFriendlyError';
import API               from '../../services/API';
import deprecated        from '../../utils/deprecated';

// @todo 2018-08-11 Remove this module once migrated to new actions (in ./actions/apiResourceActions) remove this module
deprecated(`The 'processRequestActions' module is deprecated, in favour of 'handleApiFetchRequests' module.`);

/**
 * Cache of requests in progress
 *
 * @type {{string: string}}
 */
const requestsInProgressCache = Set();


/**
 * Sets up watchers on login success
 */
export function* processApiRequests() {

  yield takeEvery((action) => {

    return isApiRequestAction(action);

  }, makeApiCall);

}

export function* makeApiCall(action) {

  const {type, payload, payload: {url, dataToSave}} = action;

  if (!url) {

    console.warn(`Action '${action.type}' not using URL, so will not handle local requests`);

    return;

  }

  const {resourceName, actionGroup, method: actionMethod} = parseApiAction(action);

  const {success, failure} = buildMethodsByActionGroup[actionGroup](resourceName, actionMethod);

  const cacheKey = `${type}:${url}`;

  if (requestsInProgressCache.contains(cacheKey)) {

    console.error('Preventing a duplicate call');

    return;

  }

  let callYield;

  if (METHOD_GET === actionMethod) {

    callYield = call(API.fetch, url);

  } else {

    callYield = call(API.save, url, actionMethod, dataToSave)

  }

  let receivedData;

  requestsInProgressCache.add(cacheKey);

  try {

    receivedData = yield callYield;

    if (!receivedData) {

      throw new UserFriendlyError('Sorry.  We were unable to retrieve the requested information');

    }

    const successAction = success({...payload, receivedData});

    yield put(successAction);

  } catch (error) {

    const failureAction = failure(error, {...payload});

    yield put(failureAction);

  } finally {

    requestsInProgressCache.delete(cacheKey);

  }

}


// WEBPACK FOOTER //
// ./src/sagas/resources/processRequestActions.js